import axios, {AxiosInstance} from "axios";
import AuthService from "../services/AuthService";


const axiosInstance: AxiosInstance = axios.create({
    baseURL: '/api/',
});

let tokenCSRF : HTMLMetaElement | null = document.head!.querySelector('meta[name="csrf-token"]');
if (tokenCSRF) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = tokenCSRF.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

axiosInstance.interceptors.request.use((config) => {
    config.params = config.params || {};
    const token = AuthService.getUserToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config;
});


export default axiosInstance;
